import { twMerge } from 'tailwind-merge'

type ClassValue = string | false | null | undefined

/**
 * Joins class names and resolves Tailwind conflicts last-wins, so a `w-28`
 * passed by a caller actually beats a component's default `w-full`.
 */
export const cn = (...values: ClassValue[]): string => twMerge(values.filter(Boolean).join(' '))
